export class TdoSubnavItemModel {
  label: string;
  isPreferNavbar = false;
  children: TdoSubnavItemModel[] = [];

  // This is for the hamburger menu
  isShowMenu: boolean = false;
  route: string;
  itemId: string;
  menuId: string;

  constructor(label: string, isPreferNavbar: boolean = false, children: TdoSubnavItemModel[] = []) {
    this.label = label;
    this.isPreferNavbar = isPreferNavbar;
    this.children = children;
  }
}
